import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccessRoleTypes } from '@next/core-lib';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { CustomerGuard } from '@next/core-lib/relationships';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PickUpGuard {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly customerGuard = inject(CustomerGuard);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.customerGuard.canActivate(route, state).pipe(
      switchMap((result) =>
        this.store.pipe(
          select(AuthorizationSelectors.selectAccessRuleForApplicationKey('GrainPickUp')),
          switchMap((userRole) => {
            if (
              userRole &&
              (userRole.RoleKey === AccessRoleTypes.Advisor ||
                userRole.RoleKey === AccessRoleTypes.Customer)
            ) {
              if (typeof result !== 'boolean') {
                return of(result);
              } else {
                return [true];
              }
            } else {
              //For any other role, skip the customer selection screen
              return [true];
            }
          }),
          take(1),
        ),
      ),
    );
  }
}
